import { render, staticRenderFns } from "./service-list.vue?vue&type=template&id=4729c905&"
import script from "./service-list.vue?vue&type=script&lang=js&"
export * from "./service-list.vue?vue&type=script&lang=js&"
import style0 from "./service-list.vue?vue&type=style&index=0&id=4729c905&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports